import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import InputField from '../../Components/InputField';
import { API_PATHS, errorMessages, URL_PATH } from '../../Utils/Constants/constants';
import { postData } from '../../Utils/AxiosRequest';
import { useNavigate } from 'react-router-dom';

const LoginOtp = ({ email, mobile, onSuccess, onFailure, resendOtp }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const [otp, setOtp] = useState('');
    const [resendOtpTimer, setResendOtpTimer] = useState(30);
    const navigate = useNavigate();

    const handleLogniWithOtp = async (e) => {
        e.preventDefault();
        if (!email || !mobile) {
            return
        }
        setIsSubmitting(true)
        const reqBody = {
            Email: email.trim(),
            EmailOTP: otp,
            MobileOTP: otp
        };

        try {
            const response = await postData(API_PATHS.verifyLoginOtp, reqBody);

            if (response.status === 200) {
                if (response.data.IsSuccess) {
                    onSuccess(response)
                } else {
                    onFailure(response.data.Message);
                }
            } else {
                onFailure(errorMessages.error)
            }
        } catch (error) {
            console.error(error);
            onFailure(errorMessages.error)
        }
        setIsSubmitting(false)
    }

    const handleOtpChange = (e) => {
        e.preventDefault()
        const value = e.target.value.toUpperCase();
        if (value.length > 6) {
            return
        }
        setOtp(value)
    }

    const createResendTimeout = () => {
        const intervalId = setInterval(() => {
            setResendOtpTimer(prvs => {
                if (prvs === 0) {
                    clearInterval(intervalId)
                    setIsResendDisabled(false);
                    return 0;
                }
                return (prvs - 1)
            });
        }, 1000)
        return intervalId;
    }

    const handleResendOtp = async (e) => {
        e.preventDefault()
        if (!email || !mobile) {
            navigate(URL_PATH.login)
        }
        await resendOtp()
    }

    useEffect(() => {
        const id = createResendTimeout()
        return () => {
            clearInterval(id)
        }
    }, [])

    return (
        <form onSubmit={handleLogniWithOtp}>
            <div className="form-group">
                <InputField
                    type="text"
                    placeholder="OTP"
                    name="Otp"
                    value={otp}
                    onChange={handleOtpChange}
                    autoComplete="off"
                    required
                />
            </div>
            <div className='mb-2'>
                <button className='btn btn-light' onClick={handleResendOtp} disabled={isResendDisabled}>
                    <small>Resend OTP {resendOtpTimer ? resendOtpTimer : ''}</small>
                </button>
            </div>

            <div className="form-group">
                {isSubmitting ? (
                    <button className="btn green-btn  w-100 cursor-na" disabled>
                        <Spinner size="sm" />
                    </button>
                ) : (
                    <input
                        type="submit"
                        className="btn green-btn  w-100"
                        value="Submit"
                    />
                )}
            </div>
        </form>
    )
}

export default LoginOtp